import {
	CountryNameFragment,
	EnrollmentApplicationGuardian,
	EnrollmentApplicationGuardianNameFragment,
} from "../../../Utilities";
import * as AddressFormat from "../Address";
import * as Fields from "./fields";

export { Fields };

/**
 * Formats the full name of the given instance.
 */
export function name(instance: EnrollmentApplicationGuardianNameFragment) {
	return Fields.name(instance.name);
}

export function address(
	instance: Pick<
		EnrollmentApplicationGuardian,
		"addressLine1" | "addressLine2" | "addressCity" | "addressPostalCode" | "addressStateOrProvince"
	> & {
		addressCountry: CountryNameFragment | null;
	},
) {
	return AddressFormat.information({
		name: "",
		addressLine1: instance.addressLine1,
		addressLine2: instance.addressLine2,
		city: instance.addressCity,
		postalCode: instance.addressPostalCode,
		stateOrProvince: instance.addressStateOrProvince,
		country: instance.addressCountry,
	});
}
